import { toast as sonner } from 'vue-sonner'

type Data = Parameters<typeof sonner>[1]

// The app's toasts (the alerts redesign, GET-113). They look the same for every tone (App.vue's Toaster and
// style.css); only how long they stay differs: an error stays until closed, a warning or anything with an action
// (Undo) gets 6 s, the rest the Toaster's 3.5 s. Import this, never vue-sonner, so every call gets those timings.
const LONG = 6000

// vue-sonner 1.x loses a toast's height when two mount in the same tick ("Branding saved" + "Render the video
// again"): each writes its height over a stale list, so the stack overlaps them. One toast per task: a second one
// in the same tick waits for the next task, when the first is mounted and measured.
let shownThisTick = false
function show(open: () => void) {
  if (shownThisTick) {
    setTimeout(() => show(open))
    return
  }
  shownThisTick = true
  queueMicrotask(() => (shownThisTick = false))
  open()
}

function message(text: string, data?: Data) {
  show(() => (data?.action ? sonner(text, { duration: LONG, ...data }) : data === undefined ? sonner(text) : sonner(text, data)))
}

export const toast = Object.assign(message, {
  success: (text: string, data?: Data) => show(() => (data === undefined ? sonner.success(text) : sonner.success(text, data))),
  info: (text: string, data?: Data) => show(() => (data === undefined ? sonner.info(text) : sonner.info(text, data))),
  warning: (text: string, data?: Data) => show(() => sonner.warning(text, { duration: LONG, ...data })),
  error: (text: string, data?: Data) => show(() => sonner.error(text, { duration: Infinity, ...data })),
  dismiss: (id?: number | string) => sonner.dismiss(id),
})
